import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Importing translation files

import translationEN from './locales/en/translation.json'
import translationTL from './locales/tl/translation.json'
import translationES from './locales/es/translation.json'
import translationFR from './locales/fr/translation.json'
import translationPL from './locales/pl/translation.json'
import translationHN from './locales/hn/translation.json'
import translationJP from './locales/jp/translation.json'
import translationCN from './locales/cn/translation.json'

//Creating object with the variables of imported translation files
export const resources = {
	en: {
		translation: translationEN,
	},
	tl: {
		translation: translationTL,
	},
	es: {
		translation: translationES,
	},
	fr: {
		translation: translationFR,
	},
	hn: {
		translation: translationHN,
	},
	jp: {
		translation: translationJP,
	},
	cn: {
		translation: translationCN,
	},
	pl: {
		translation: translationPL,
	},
}

export function isLocaleAvailable() {
    // Extracting the primary language code by splitting at the hyphen (if present) or taking the whole string
    const locale = Intl?.DateTimeFormat()?.resolvedOptions()?.locale;
    const languageCode = locale?.split('-')?.[0];
    
    // Checking for specific languages (e.g., French and Polish)
    if (locale === 'fr' || locale === 'pl') {
        return `${locale.toLowerCase()}-${locale.toUpperCase()}`;
    }

    // Otherwise, checking if the language code exists in the resources object, otherwise return 'en'
    return resources?.hasOwnProperty(languageCode) ? languageCode : 'en';
}


//i18N Initialization

i18n.use(initReactI18next).init({
	resources,
	// lng: 'en', //default language
	lng: isLocaleAvailable(), //default language
	keySeparator: '.',
	interpolation: {
		escapeValue: false,
	},
})

export default i18n
